import React from 'react';

// DEPENDENCIES
import isArray from 'lodash/isArray';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints';

// PARTS
import Card from 'parts/card/Card';
import Record from 'parts/record/Record.js';

// LOCAL COMPONENTS
import CustomerRebatesForm from './parts/CustomerRebatesForm.js';

// MAIN COMPONENT
const CustomerRebatesUpdate = () => (
  <Record.Update
    recordLabel="customer rebate"
    endpoints={ENDPOINTS.admin.dealerRebates}
    initialValues={{
      rebate_models: [],
      documentAttachment: {},
      is_active: 1,
      trim_selection: 0
    }}
    formatParams={(params = {}) => {
      const { rebate_program_docs, customer_sig_forms } = params.documentAttachment || {};
      // TODO: Determine why a temp upload adds the attachement as an object and not an array
      return {
        ...params,
        documentAttachment: {
          rebate_program_docs: rebate_program_docs && !isArray(rebate_program_docs) ? [rebate_program_docs] : rebate_program_docs,
          customer_sig_forms: customer_sig_forms && !isArray(customer_sig_forms) ? [customer_sig_forms] : customer_sig_forms
        }
      };
    }}
    formatRecord={record => ({
      ...record,
      effective_date: record?.effective_date === null ? '' : record?.effective_date,
      expiration_date: record?.expiration_date === null ? '' : record?.expiration_date,
    })}
  >
    <Card body={<CustomerRebatesForm />} />
  </Record.Update>
);

// EXPORT
export default CustomerRebatesUpdate;
